import Controller from './analytics-controller'

export default class extends Controller {
  handleClickReferral ({ target }) {
    const linkElement = target.closest('[data-gtm-track="article-referral-click"]')

    if (linkElement) {
      const currentPath = location.pathname
      const linkHrefValue = linkElement.href

      this.labelValue = `${currentPath} — ${linkHrefValue}`
      this.sendEvent()
    }
  }
}
